// check if obj is empty
export function isEmpty(obj: Record<any, any>) {
  if (obj == null) return true;
  if (Array.isArray(obj)) return obj.length === 0;
  if (typeof obj !== 'object') return false;
  return Object.keys(obj).length === 0;
}
